import { Component } from '@angular/core';

@Component({
    selector: 'app-store-finder-header',
    templateUrl: './store-finder-header.component.html',
    styleUrl: './store-finder-header.component.scss',
    standalone: false
})
export class StoreFinderHeaderComponent {

}
